<template>
	<div class="PlayersScreen">
		<SectionWrapper class="Cover" :backgroundImage="require(`@/assets/imgs/main/photo-06.webp`)">
			<div class="TeamPicture" :style="{ backgroundImage: `url(${require(`@/assets/imgs/main/photo-09.webp`)})` }" />
		</SectionWrapper>

		<div class="Wrapper">
			<SectionWrapper title="Jugadoras" :useGradientBackground="false">
				<div class="Grid">
					<!-- @click="openModal(person.driveLink)" -->
					<div v-for="(person, index) in players" :key="`player-${index}`" class="GridItem"
						@mouseenter="hovered = person.number" @mouseleave="hovered = null">

						<div class="ProfilePicture" :style="getStyle(person.number)" />
						<div class="ProfileName">
							<p class="Name">
								{{ person.alias }}
							</p>
							<p class="Number">
								#{{ person.number }}
							</p>
						</div>
					</div>
				</div>
			</SectionWrapper>

			<SectionWrapper title="Equipo Técnico" description="Encargado de coordinar los entrenamientos, la preparación física, las
					estrategias de juego y las labores de apoyo y asistencia al equipo." :useGradientBackground="false">
				<div class="Grid">
					<!-- @click="openModal(driveLink)" -->
					<div v-for="({ name, role, id }, index) in tecnicMembers" :key="`tecnic-${index}`" class="GridItem"
						@mouseenter="hovered = id" @mouseleave="hovered = null">
						<!-- Tenemos un equipo técnico encargado de organizar los entrenamientos, la preparación física y las
					estrategias de juego. -->
						<!-- :style="{ backgroundImage: `url(${require(`@/assets/imgs/roster/${image || 'default.webp'}`)})` }"  -->
						<div class="ProfilePicture" :style="getStyle(id)" />
						<div class="ProfileName vertical">
							<p class="Name">
								{{ name }}
							</p>
							<p class="Role">
								{{ role }}
							</p>
						</div>

					</div>
				</div>
			</SectionWrapper>

			<!-- <SectionWrapper title="Comité Organizativo"
				description="Encargado de realizar toda la organización y gestión general." :useGradientBackground="false">
				<div class="Grid">
					<div v-for="({ name, role, number }, index) in comiteMembers" :key="`player-${index}`" class="GridItem"
						@mouseenter="hovered = person.number" @mouseleave="hovered = null">

						<div class="ProfilePicture" :style="getStyle(number)" />
						<div class="ProfileName vertical">
							<p class="Name">
								{{ name }}
							</p>
							<p class="Role">
								{{ role }}
							</p>
						</div>
					</div>
				</div>
			</SectionWrapper> -->



			<!-- <iframe class="TeamVideo"
				src="https://www.youtube.com/embed/QVgU08KuQZ8?si=Ydfoq-5EyzoOJzVG?controls=0&modestbranding=1&rel=0&showinfo=0"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen /> -->
		</div>
		<!-- cambiar esta foto -->
		<SplideWrapper v-if="videos.length" :items="videos" title="Así somos" type="Shorts"
			:backgroundImage="require(`@/assets/imgs/main/photo-02.webp`)" description=""
			:contentSize="{ width: 231, height: 410 }" :avoidWide="false">
		</SplideWrapper>
		<SplideWrapper v-if="activities.length" :items="activities" title="Eventos & Actividades" type="Images"
			:avoidWide="false" :useGradientBackground="false" :heightAuto="false" :autoWidthProp="false">
		</SplideWrapper>
		<Modal :isOpen="isModalOpen !== null" @close="isModalOpen = null">
			<template #body>
				<iframe :src="`https://drive.google.com/file/d/${isModalOpen}/preview`" frameborder="0" allow="autoplay"
					allowfullscreen />
			</template>
		</Modal>
	</div>
</template>

<script>
import { mediaQueryMixin } from "@/mixins";
import { players, tecnicMembers, comiteMembers, activities } from '@/utils/publicData'
import { SplideWrapper, SectionWrapper } from '@/components'

export default {
	name: 'PlayersScreen',
	components: {
		SplideWrapper,
		SectionWrapper
	},
	mixins: [mediaQueryMixin],
	data() {
		return {
			hovered: null,
			isModalOpen: null,
			videos: [
				{
					shortId: 'x_sy0zl7ffs'
				},
				{
					shortId: 'fckVcKo10VI'
				},
				{
					shortId: 'JH_JsuNpezg'
				},
				{
					shortId: 'GNPJRuizK80'
				},
				{
					shortId: 'bQlZS2aNuQU'
				},
			],
			activities,
			players,
			tecnicMembers,
			comiteMembers,
		}
	},
	computed: {
		isMobile() {
			return this.$mq.w < this.$mq.sm.min;
		},
		isTablet() {
			return this.$mq.w < this.$mq.md.min;
		},
	},
	methods: {
		getStyle(id, hasAltPhoto = true) {
			const isHover = this.hovered === id
			let img = 'default.webp'
			if (id) {
				img = isHover && hasAltPhoto ? `hover/${id}.webp` : `${id}.webp`
				// img = `${id}.webp`
			}
			return {
				backgroundImage: `url(${require(`@/assets/imgs/roster/${img}`)})`
			}

		},
		// openModal(driveLink) {
		// 	console.log('click', driveLink)
		// 	if (driveLink) {
		// 		this.isModalOpen = driveLink
		// 	}
		// 	// this.modalImage = value
		// },
		//	async formatPlayers() {
		// 		const players = this.organization

		// 		return players.map((p) => {
		// 			const player = p
		// 			player.userPositions = p.userPositions
		// 				.filter(p => p.position.type === constants.POSITION_TYPE.DEFENSIVE)
		// 			player.positionText = userIntegration.getPositionText({ items: player.userPositions })
		// 			player.startDate = (p.startDate &&
		// 				moment(p.startDate).endOf('day').locale('es').fromNow(true)) || '-'
		// 			player.number = (p.userUniforms && p.userUniforms.length &&
		// 				`#${p.userUniforms[0].number}`) || ''
		// 			return player
		// 		})
		// 	},
	},
}
</script>

<style lang="scss" scoped>
.PlayersScreen {
	width: 100%;
	background: #333;
	margin-bottom: 2rem;

	@media screen and (max-width: $sm) {
		margin-bottom: 0;
	}

	@media screen and (min-width: $xl) {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.SplideWrapper {
		margin-top: 2rem;
	}

	.Cover {
		position: absolute;
		height: 30rem;
		width: 100%;
		top: 0;
		left: 0;

		@media screen and (max-width: $sm) {
			height: 16rem;
		}

		.TeamPicture {
			z-index: 10;
			width: 100%;
			height: 35rem;
			border-radius: 20px;
			background-size: cover;
			background-repeat: no-repeat;
			background-position-x: center;
			background-position-y: center;
			align-self: center;
			margin: 0 auto;
			margin-top: 4rem;


			@media screen and (max-width: $md) {
				height: 30rem;
			}

			@media screen and (max-width: $sm) {
				margin-top: 3rem;
				height: 14rem;
			}

			@media screen and (min-width: $lg) {
				width: 70%;
			}

			@media screen and (min-width: $xl) {
				width: 100%;
			}

		}

	}


	.Wrapper {
		margin-top: 42rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;

		@media screen and (min-width: $xl) {
			width: 1300px;
		}

		@media screen and (max-width: $md) {
			margin-top: 37rem;
		}

		@media screen and (max-width: $sm) {
			margin-top: 20rem;
		}

		.TeamVideo {
			margin: 50px 0 100px;
			width: 80%;
			height: 500px;
			border-radius: 20px;

			@media screen and (max-width: $md) {
				height: 350px;
			}

			@media screen and (max-width: $sm) {
				height: 250px;
				margin-top: 100px;
			}
		}

		.Grid {
			// margin: 50px;
			width: 100%; //80%;
			display: grid;
			grid-template-columns: repeat(5, 1fr);
			grid-column-gap: 20px;
			grid-row-gap: 20px;
			grid-template-rows: 1fr;

			@media screen and (max-width: $xl) {
				grid-template-columns: repeat(6, 1fr);
			}

			@media screen and (max-width: $lg) {
				grid-template-columns: repeat(4, 1fr);
			}

			@media screen and (max-width: $md) {
				grid-template-columns: repeat(3, 1fr);
			}

			@media screen and (max-width: $sm) {
				grid-template-columns: repeat(2, 1fr);
			}

			.GridItem {
				background: white;
				overflow: hidden;
				border-radius: 10px;
				box-shadow: 0px 4px 10px rgba(103, 94, 134, 0.1);
				display: flex;
				flex-direction: column;
				align-items: center;
				// cursor: pointer;
				padding-bottom: 12px;
				position: relative;
				transition: all .3s;

				cursor: pointer;

				&:hover {
					transform: scale(1.05);
				}


				// &:hover {
				// 	.PersonInfo {
				// 		opacity: 1;
				// 		bottom: 0;
				// 	}
				// }

				.ProfilePicture {
					width: 100%;
					height: 14rem;
					background-color: $gray-07;
					background-position: center;
					background-size: cover;
					background-repeat: no-repeat;
					display: flex;
					align-items: center;
					justify-content: center;

					@media screen and (max-width: $sm) {
						height: 10rem;
					}
				}

				.ProfileName {
					display: flex;
					align-items: space-between;
					justify-content: space-between;
					margin-top: 12px;
					padding: 0 12px;
					position: relative;
					width: 100%;


					&.vertical {
						flex-direction: column;
						align-items: center;
						justify-content: center;
					}
				}

				p {
					color: $gray-dark !important;
					font-weight: 700;
					font-size: 18px;
					// margin: 12px;
				}

				p.Number {
					color: #333 !important;
				}

				p.Role {
					color: #333 !important;
					font-size: 14px;
					text-transform: uppercase;
					margin-top: 8px;
				}



				// .PersonInfo {
				// 	position: absolute;
				// 	left: 0;
				// 	width: 100%;
				// 	height: 100%;
				// 	background: $primary;
				// 	display: flex;
				// 	flex-direction: column;
				// 	align-items: center;
				// 	justify-content: center;
				// 	opacity: 0;
				// 	padding: 20px;
				// 	transition: all .3s;
				// 	bottom: -100%;

				// 	p {
				// 		color: white !important;
				// 		font-size: 16px;
				// 		line-height: 24px;
				// 	}

				// 	.Name {
				// 		font-size: 18px;
				// 		line-height: 26px;
				// 		font-weight: bold;
				// 	}

				// 	.Icon {
				// 		margin-right: 5px;
				// 	}

				// 	.Position {
				// 		text-align: center;
				// 		width: 100%;
				// 	}
				// }
			}
		}
	}

	.Modal::v-deep {
		.Dialog {
			max-width: 100%;
			width: fit-content;
		}

		.Body {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 2rem 2rem 2rem;
		}

		iframe {
			height: 30rem;
			border-radius: 1rem;

			@media screen and (max-width: $sm) {
				height: calc(100vh - 7rem)
			}

		}
	}
}
</style>
